import { Component, OnInit } from '@angular/core';
import { InvoiceSaleService } from '../../inventory/sales/invoice-sale/invoice-sale.service';
import { CashClosureAccountRequest, CashClosureRequest } from 'src/app/models/cash-closure.model';
import { ToastrService } from 'ngx-toastr';
import { ResponseObject } from 'src/app/models/response-object.model';
import { BankService } from 'src/app/services/bank.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AccountResponse, ErpBankResponse } from 'src/app/models/account.model';
import { concatMap, finalize } from 'rxjs/operators';
import { CardTypeResponse } from 'src/app/models/card.model';
import { CashClosureService } from 'src/app/services/cash-closure.service';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { ActivatedRoute } from '@angular/router';
import { CompanyService } from 'src/app/services/company.service';
declare let $: any;

@Component({
  selector: 'app-cash-closure',
  templateUrl: './cash-closure.component.html',
  styleUrls: ['./cash-closure.component.scss']
})
export class CashClosureComponent implements OnInit {
  loading = false;
  cashiers = [];
  accountReceivable = [];
  banks: ErpBankResponse[] = [];
  accounts: AccountResponse[] = []
  bank = null;
  dragging = false;
  cashClosureRequest: CashClosureRequest = new CashClosureRequest();
  closed = false;
  balances = {
    cash: {
      user: 0,
      system: 5,
    },
    transfer: {
      user: 0,
      system: 0,
    },
    card: {
      user: 0,
      system: 0
    },
    check: {
      user: 0,
      system: 5
    },
    total: {
      user: 0,
      system: 5
    }
  };
  typeCards: CardTypeResponse[] = [];
  user = null;
  date = new Date();

  constructor(
    private toastService: ToastrService,
    private bankService: BankService,
    private invoiceService: InvoiceSaleService,
    private cashService: CashClosureService,
    private authService: AuthenticationService,
    private route: ActivatedRoute,
    private companyService: CompanyService
  ) {
    this.user = this.authService.getUserPosition();
  }

  saveClosure() {
    if (this.loading) {
      return;
    }
    this.loading = true;
    var request = Object.assign({}, this.cashClosureRequest);
    request.accounts = [];
    this.cashService.createCashClosure(this.cashClosureRequest)
    .pipe(finalize(() => this.loading = false))
    .subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Se guardaron correctamente los datos!");
        this.reset();
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }

  reset() {
    this.balances = {
      cash: {
        user: 0,
        system: 5,
      },
      transfer: {
        user: 0,
        system: 0,
      },
      card: {
        user: 0,
        system: 0
      },
      check: {
        user: 0,
        system: 5
      },
      total: {
        user: 0,
        system: 5
      }
    };
    this.cashClosureRequest = new CashClosureRequest();
    document.getElementById("toUpload2")['value'] = null;
  }

  ngOnInit(): void {
    var id = this.route.snapshot.paramMap.get('id');
    if (id) {
      if (!isNaN(parseInt(id))) {
        this.companyService.getEventById(parseInt(id)).subscribe({
          next: (response: ResponseObject) => {
            if (response.data.rollbackDate) {
              this.cashClosureRequest.rollback = true;
              this.cashClosureRequest.date = response.data.rollbackDate;
              this.date = new Date(response.data.rollbackDate);
              this.toastService.info("Se asigna el día del que se hizo el rollback");
            } else {
              this.toastService.error("El evento enviado no es un rollback");
            }
          },
          error: (error: HttpErrorResponse) => {
            this.toastService.error("Error al obtener el día al cual corresponde el rollback");
          }
        })
      } else {
        this.toastService.info("La información enviada no es correcta, se muestra un listado de cuentas por cobrar normal");
      }
    }
    this.invoiceService.getCash().pipe(
      concatMap((response: ResponseObject) => {
        if (this.user) {
          const unique = new Set<number>();
          this.user.forEach((elemento) => {
            unique.add(elemento.cash);
          });
          const filter = Array.from(unique);
          this.cashiers = response.data.filter(cash => filter.includes(cash.id));
          if (this.cashiers.length == 1) {
            this.cashClosureRequest.data.idCashier = this.cashiers[0].id;
          }
        }
        return this.bankService.getBanks();
      }),
      concatMap((response: ResponseObject) => {
        this.banks = response.data;
        this.bank = this.banks[0].id;
        return this.invoiceService.getCardTypes();
      }),
      concatMap((response: ResponseObject) => {
        this.typeCards = response.data;
        return this.invoiceService.getBankActiveAccounts();
      })
    ).subscribe(
      (response: ResponseObject) => {
        this.accounts = response.data;
      },
      (error) => {
        console.log("Error al comunicarse con el servidor");
      }
    );
  }

  getTodayDate(): string {
    const months = [
      'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
      'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
    ];
    const day = this.date.getDate();
    const month = months[this.date.getMonth()];
    const year = this.date.getFullYear();
    return `${day} de ${month} de ${year}`;
  }

  verifiedInput(event: any) {

  }

  addPhoto(event: any) {
    const archivos = event.target.files;

    for (let i = 0; i < archivos.length; i++) {
      const file = event.target.files[i];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result;
          this.cashClosureRequest.images.push(base64String.toString());
        };
        reader.readAsDataURL(file);
      }
    }

  }

  addPhotos() {
    document.getElementById('toUpload2').click();
  }

  addPhotosDrop(event: any) {
    event.preventDefault();
    const archivos = event.dataTransfer.files;

    for (let i = 0; i < archivos.length; i++) {
      const file = event.target.files[i];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result;
          this.cashClosureRequest.images.push(base64String.toString());
        };
        reader.readAsDataURL(file);
      }
    }
    this.dragging = false;
  }

  allowDrop(event: any) {
    event.preventDefault();
    this.dragging = true;
  }

  deletePhoto(position) {
    this.cashClosureRequest.images.splice(position, 1);
  }
}
